import { filterFields } from './FilterFields/dataExplorerFieldsConfig';
import { regionFilterFields } from './FilterFields/RegionGroup';
import { RangeFieldTransformer } from './FieldTransformers/FieldTransformers';
import { auxiliaryFields } from './auxiliaryFields';
import { useRouteMatch } from 'react-router-dom';
import {
  DATA_FIELD_LIST_PATH,
  DATA_FIELD_PATH,
  DATASET_LIST_PATH,
  MAIN_DATA_PATH,
  SINGLE_DATASET_PATH,
  SINGLE_DATASET_TABS,
} from '../dataExplorerRouterPaths';
import { useCallback } from 'react';
import analytics, { EventOptions } from '../../../shared/services/analytics/analytics';

//const turnover = new RangeFieldTransformer(regionFilterFields.turnover.name).getOutputKeys();
const coverage = new RangeFieldTransformer(regionFilterFields.coverage.name).getOutputKeys();
const dateCoverage = new RangeFieldTransformer(regionFilterFields.dateCoverage.name).getOutputKeys();
const valueScore = new RangeFieldTransformer(filterFields.valueScore.name).getOutputKeys();
const alphaCount = new RangeFieldTransformer(filterFields.alphaCount.name).getOutputKeys();

export const DATASET_FILTERS_ANALYTICS_KEYS = {
  [filterFields.search.name]: 'de_change_search',
  [filterFields.region.name]: 'de_change_region',
  [filterFields.delay.name]: 'de_change_delay',
  [filterFields.universe.name]: 'de_change_universe',
  [filterFields.type.name]: 'de_change_type',
  [filterFields.category.name]: 'de_change_category',
  [filterFields.subcategory.name]: 'de_change_category',
  [filterFields.subcategory.name]: 'de_change_category',
  [auxiliaryFields.limit.name]: 'de_change_page_size',
  [auxiliaryFields.offset.name]: 'de_change_page',
  // [turnover.min]: 'de_change_turnover_min',
  // [turnover.max]: 'de_change_turnover_max',
  [coverage.min]: 'de_change_coverage_min',
  [coverage.max]: 'de_change_coverage_max',
  [dateCoverage.min]: 'de_change_coverage_min',
  [dateCoverage.max]: 'de_change_coverage_max',
  [valueScore.min]: 'de_change_value_score_min',
  [valueScore.max]: 'de_change_value_score_max',
  [alphaCount.min]: 'de_change_alpha_count_min',
  [alphaCount.max]: 'de_change_alpha_count_max',
  [filterFields.theme.name]: 'de_change_theme_filter',
  [filterFields.dateCreated.name]: 'de_change_date_added',
  [filterFields.dateUpdated.name]: 'de_change_last_field_added',
} as const;

export const formatOrderEventName = (value: { key?: string; isAscending?: boolean } = {}) => {
  return `de_change_order_${value?.key}_${value?.isAscending ? 'asc' : 'desc'}`;
};

export const PATH_ANALYTICS_KEYS = {
  [MAIN_DATA_PATH]: 'main',
  [DATASET_LIST_PATH]: 'datasets_list',
  // we have 2 tabs which are parameters in urls (fields, description)
  [SINGLE_DATASET_PATH]: 'dataset_',
  [DATA_FIELD_PATH]: 'field',
  [DATA_FIELD_LIST_PATH]: 'fields_list',
} as const;

export const useDataExplorerAnalyticsPage = () => {
  const route = useRouteMatch();
  let page = PATH_ANALYTICS_KEYS[route.path] || route.path;
  if (route.path === SINGLE_DATASET_PATH) {
    page +=
      (route.params as { tab?: keyof typeof SINGLE_DATASET_TABS }).tab === SINGLE_DATASET_TABS.description
        ? SINGLE_DATASET_TABS.description
        : SINGLE_DATASET_TABS.fields;
  }

  return page;
};

export const useDataExplorerTrackCustomEvent = () => {
  const page = useDataExplorerAnalyticsPage();
  const trackCustomEvent = useCallback(
    (event: string, options?: EventOptions) => {
      analytics.trackCustomEvent(event, { event_label: page });
    },
    [page]
  );

  return trackCustomEvent;
};
